import { ACTIONS } from './constants';

const messagingSummaryDrawer = (state = {}, action = {}) => {
    switch (action.type) {
        case ACTIONS.OPEN_SUMMARY_DRAWER:
            return {
                programWorkoutId: action.programWorkoutId,
                teamId: action.teamId,
                title: action.title,
                date: action.date,
                athleteId: action.athleteId,
                open: true
            };
        case ACTIONS.CLOSE_SUMMARY_DRAWER:
            return {
                open: false
            };
        default:
            return state;
    }
};

export default messagingSummaryDrawer;



// WEBPACK FOOTER //
// ./src/v5/messaging/state/reducer.js